import {BoxProps} from '@chakra-ui/react';
import React, {memo, useState} from 'react';
import {Row, UiBox, UiIcon, UiImage, UiText} from '~/components/elements';
import {AppCarousel} from '~/components/elements/AppCarousel';
import {UserReview} from '~/types/models/questionnaire';
import {FaStar} from 'react-icons/fa';
import {TestimonialEntity} from '~/types/models/testimonial';

interface Props extends BoxProps {
  reviewList?: TestimonialEntity[];
}

const getStarList = (rating: number) => {
  const starList = [];
  for (let i = 0; i < rating; i++) {
    starList.push(i);
  }
  return starList;
};

export const ReviewList = memo(function ReviewList({reviewList = [], ...rest}: Props) {
  const [selectedItem, setSelectedItem] = useState(0);

  const renderList = () =>
    reviewList?.map((item, index) => (
      <UiBox key={item?.content} px={2}>
        <Row display="flex" flex={1} justifyContent="center" mb={3}>
          {getStarList(item?.rating).map(i => (
            <UiIcon as={FaStar} key={i} color="#EFAD6A" boxSize={6} />
          ))}
        </Row>
        <UiText textAlign="center" fontSize="xs" lineHeight={6} mb={2}>
          {item?.content}
        </UiText>
        <UiText fontWeight="700">- {item?.name}</UiText>
      </UiBox>
    ));
  return (
    <UiBox w="100%" {...rest}>
      <AppCarousel
        selectedItem={selectedItem}
        onChange={index => setSelectedItem(index)}
        onClickItem={index => setSelectedItem(index)}
        showIndicators={false}
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        autoPlay
        infiniteLoop
      >
        {renderList()}
      </AppCarousel>
    </UiBox>
  );
});
